// Health API → backend /health (status + database + version).
import { api } from "./client";

export const getHealth = () => api.get("/health");
